export default {
	username:sessionStorage.getItem("username") != null?sessionStorage.getItem("username"):'未登录',
	id:sessionStorage.getItem("id") != null?sessionStorage.getItem("id"):'未登录',
	school_id:sessionStorage.getItem("school_id") != null?sessionStorage.getItem("school_id"):'未登录',
	rid:sessionStorage.getItem("rid") != null?sessionStorage.getItem("rid"):'未登录',
	token:sessionStorage.getItem("token") != null?sessionStorage.getItem("token"):'未登录',
	college_id:sessionStorage.getItem("college_id"),
	img:sessionStorage.getItem("img"),
	authid:sessionStorage.getItem("authid"),
	caid:sessionStorage.getItem("caid"),
	college_id:sessionStorage.getItem("college_id"),
	comm_id:sessionStorage.getItem("comm_id"),
	// 用户账号列表
	userlist:{
		tabledata:[],
		page:1,
		count:0,
		total:0
	},
	ruleForm: {
		uid:sessionStorage.getItem("id"),
		title: '',
		img: '',
		file:[],
		content: '',
		token: sessionStorage.getItem("token")
	},
	// 新闻列表
	newslist:{
		tabledata:[],
		page:1,
		total:0,
		count:0,
		imageUrl:'',
		reason:"",
		disabled:false,
		type:"add",
		upfm:"上传封面",
		uploaddata:{
			id:"",
			title:"",
			uid:"",
			moduleClass:[],
			status:"6",
			content:"",
			pubtime:"",
			pubuser:"",
			sz_img:"",
			banner:0
		},
	},
	// 资源
	resourcelist:{
		tabledata:[],
		page:1,
		total:0,
		count:0,
		bsid:"5",
		imageUrl:'',
		reason:"",
		disabled:false,
		num:'',
		upfm:"上传封面",
		uploadtype:"",
		type1:"add",
		fileList:[],
		uploaddata:{
			uid:sessionStorage.getItem("id"),
			school_id:sessionStorage.getItem("school_id"),
			id:"",
			title:"",
			level:"",
			bsid:"",
			mid:1,
			mid2:1,
			isdown:1,
			token:sessionStorage.getItem("token"),
			mid3:'',
			famous_teacher:[],
			team_teacher:[],
			keys:[],
			a_url:[],//pdf文件
			v_url:[],//视频文件
			p_url:[],//ppt文件
			h_url:[],//pdf文件
			status:"1",
			confirm:[],
			sz_img:"",
			content:"",
			teacher:"",
			college_id:sessionStorage.getItem("college_id"),
			company:"",
			range:1,//资源权限
		},
	},
	// 内容审核
	examine:{
		tabledata:[],
		page:1,
		total:0,
		count:0,
		bsid:"",
	},
	// 引经用典
	yjyd:{
		tabledata:[],
		page:1,
		total:0,
		count:0,
		type:"add",
		disabled:false,
		reason:"",
		uploaddata:{
			id:"",
			title:"",//标题
			class_id:"",//模块
			subtitle:"",//摘要
			unscramble:"",//解读
			original:"",//原典
			interpretation:"",//释义
			keys:[],//关键字，
			status:6
		},
	}
}